// extracted by mini-css-extract-plugin
export default {"group":"group--ggdQe","parent":"parent--e65dE","child":"child--xKNe9"};